import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { popUps } from "./utils/data"

function PopUp({ setPopUpFalse, popUp }) {

  const history = useHistory()

  useEffect(() => {
    if (!popUp || !popUps[popUp]) return setPopUpFalse()
  }, [popUp])

  const Component = popUps[popUp]

  return (
    <div className="fixed top-0 w-full popup left-0">
      <section className="min-h-view flex flex-col w-full gap-4 saira font-bold items-center h-view popup__container">
        {popUps[popUp] && <Component history={history} setPopUpFalse={setPopUpFalse} />}
      </section>
    </div>
  )
}

export default PopUp